import { useOutletContext } from "react-router-dom";
import PageBanner from "@/components/site/PageBanner";
import NewsSection from "@/components/site/NewsSection";
import DownloadSection from "@/components/site/DownloadSection";
import RankingSection from "@/components/site/RankingSection";
import RegisterSection from "@/components/site/RegisterSection";

const Shell = ({ children }) => (
  <div className="relative pt-16">
    <PageBanner />
    <div className="relative">{children}</div>
  </div>
);

export const NewsPage = () => <Shell><NewsSection /></Shell>;
export const DownloadPage = () => { const { settings } = useOutletContext(); return <Shell><DownloadSection settings={settings} /></Shell>; };
export const RankingPage = () => <Shell><RankingSection /></Shell>;
export const RegisterPage = () => { const { settings } = useOutletContext(); return <Shell><RegisterSection settings={settings} /></Shell>; };
